// Session identity for anon users. Persisted in localStorage so cloned
// voices remain visible across sessions on the same browser. Attached to
// axios as X-Session-Id so the backend can scope /api/voices/mine to the
// caller without requiring an auth flow.
import axios from "axios";

const KEY = "audioflip_session_id";

function readOrCreate() {
  try {
    const existing = localStorage.getItem(KEY);
    if (existing) return existing;
  } catch {
    /* fallthrough */
  }
  const fresh =
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `sid-${Math.random().toString(36).slice(2)}-${Date.now()}`;
  try {
    localStorage.setItem(KEY, fresh);
  } catch {
    /* private mode */
  }
  return fresh;
}

const SESSION_ID = readOrCreate();
axios.defaults.headers.common["X-Session-Id"] = SESSION_ID;

export function getSessionId() {
  return SESSION_ID;
}
